<template>
  <div class="mod-overlay">
    <div class="mod-modal">
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar motivo de rechazo' : 'Nuevo motivo de rechazo' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')"><i class="bi bi-x-lg"></i></button>
      </div>

      <form @submit.prevent="handleSubmit" class="mod-modal-body">
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i> {{ error }}
        </div>

        <div class="mod-form-grid">
          <div class="mod-field">
            <label for="Tipo">Tipo <span class="mod-required">*</span></label>
            <input type="text" id="Tipo" v-model="form.Tipo" :disabled="isEdit" required maxlength="10" placeholder="GENERAL">
          </div>
          <div class="mod-field">
            <label for="Clave">Codigo <span class="mod-required">*</span></label>
            <input type="text" id="Clave" v-model="form.Clave" :disabled="isEdit" required maxlength="10" placeholder="Codigo del motivo">
          </div>
          <div class="mod-field">
            <label for="EmpresaId">Empresa ID <span class="mod-required">*</span></label>
            <input type="number" id="EmpresaId" v-model.number="form.EmpresaId" :disabled="isEdit" required min="1" placeholder="Empresa">
          </div>
          <div class="mod-field">
            <label for="Nombre">Nombre <span class="mod-required">*</span></label>
            <input type="text" id="Nombre" v-model="form.Nombre" required placeholder="Nombre del motivo">
          </div>
          <div class="mod-field mod-field-check">
            <label class="mod-check-label">
              <input type="checkbox" v-model="form.EsActivo">
              <span>Activo</span>
            </label>
          </div>
        </div>

        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">Cancelar</button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else><i class="bi bi-check-lg"></i> {{ isEdit ? 'Guardar cambios' : 'Crear motivo' }}</template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import motivorechazoService from './motivorechazo.service';
import { showToast } from '@/shared/utils/toast';
import authService from '@/services/auth';
import { createMotivoRechazo } from './motivorechazo.model';

export default {
  name: 'MotivoRechazoForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return { form: createMotivoRechazo(), saving: false, error: null };
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
    } else {
      const empresa = authService.getSelectedEmpresa();
      this.form.EmpresaId = empresa?.EmpresaId || 0;
      this.form.Tipo = 'GENERAL';
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;
      if (!this.form.Tipo || !this.form.Clave || !this.form.EmpresaId || !this.form.Nombre) {
        this.error = 'Tipo, codigo, empresa y nombre son obligatorios';
        this.saving = false;
        return;
      }
      try {
        const result = await motivorechazoService.guardar(this.form);
        if (result && (result.Number >= 0 || result.Clave)) { showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved'); }
        else { this.error = (result && result.Message) || 'Error al guardar'; }
      } catch (e) {
        console.error('Error al guardar:', e);
        this.error = 'Error de conexion con el servidor';
      } finally { this.saving = false; }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";
</style>
